import * as React from 'react';
import { compose, pure } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import { border, toCssValue } from '@topconagriculture/theme';
import { FontIcon } from '../FontIcon';
const styles = (theme) => createStyles({
    sectionMenu: {
        display: 'grid',
        marginBottom: theme.space.margin.large,
    },
    sectionHeader: {
        width: '100%',
        padding: toCssValue([0, theme.space.padding.small]),
        marginBottom: theme.space.margin.default,
        borderBottom: border(theme.color.grey.light, 1, 'dashed'),
        textTransform: 'uppercase',
        fontWeight: 'bold',
        fontSize: 24,
        color: theme.color.font.dark,
    },
    sectionIcon: {
        fontSize: 24,
        color: theme.color.font.dark,
        marginRight: theme.space.margin.small,
    },
});
const SectionMenuWrapper = (props) => {
    const { classes, children, className: classNameProp, menuLabel, columns = 5, gap = 50, iconName, testId = 'SectionMenuWrapper', } = props;
    return (React.createElement("div", { className: classNameProp, "data-testid": `${testId}` },
        menuLabel && (React.createElement("div", { className: classes.sectionHeader, "data-testid": `${testId}-header` },
            iconName && React.createElement(FontIcon, { top: 2, className: classes.sectionIcon, iconName: iconName }),
            menuLabel)),
        React.createElement("div", { "data-testid": `${testId}-content`, className: classes.sectionMenu, style: {
                gridTemplateColumns: `repeat(${columns}, 1fr)`,
                gridGap: `40px ${gap}px`,
            } }, children)));
};
const ComposedSectionMenuWrapper = compose(withStyles(styles, { withTheme: true }), pure)(SectionMenuWrapper);
ComposedSectionMenuWrapper.displayName = 'SectionMenuWrapper';
export default ComposedSectionMenuWrapper;
//# sourceMappingURL=SectionMenuWrapper.js.map